<template>
  <tk-flex middle class="m-b-16" style="cursor: pointer;">
    <a-icon
      v-if="showBack"
      type="left"
      @click.native="showBack? $router.back() : null"
      style="margin-right: 13px;color: #000000;font-size: 18px;"
    />
    <div
      @click="showBack? $router.back() : null"
      style="font-size: 18px;color:#060A13;font-weight: bold;"
    >{{ title }}</div>
  </tk-flex>
</template>
<script>
export default {
  props: {
    title: String,
    showBack: Boolean
  },
  data () {
    return {}
  }
}
</script>
